<template>
  <h1 class="uppercase">
    {{ $t(`messages.gameRankingReport.${tableHeader}`) }}
  </h1>
  <div
    class="ranking-table rounded-md shadow-md bg-white overflow-auto"
    style="max-height: 300px"
  >
    <div>
      <p class="ml-4">
        <strong>{{ $t("messages.gameRankingReport.win") }}</strong>
      </p>
      <div
        class="flex justify-around ml-4"
        v-for="(data, index) in winRows"
        :key="index"
      >
        <ShowUpline :type="tableType" :data="data" />

        <div
          class="w-full"
          :style="{ color: Number(data.winLoss / 100) < 0 ? 'red' : 'green' }"
        >
          <p class="text-left">
            {{ Number(data.winLoss / 100).toLocaleString() }}
          </p>
        </div>
      </div>
    </div>
    <div>
      <p class="ml-4">
        <strong>{{ $t("messages.gameRankingReport.loss") }}</strong>
      </p>
      <div
        class="flex justify-around ml-4 gap-2"
        v-for="data in lossRows"
        :key="data"
      >
        <ShowUpline :type="tableType" :data="data" />

        <div
          class="w-full"
          :style="{ color: Number(data.winLoss / 100) < 0 ? 'red' : 'green' }"
        >
          <p class="text-left">
            {{ Number(data.winLoss / 100).toLocaleString() }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { watch, onMounted, ref } from "vue";
import { useStore } from "vuex";
import ShowUpline from "./ShowUpline.vue";

export default {
  props: {
    tableHeader: {
      type: String,
      default: "",
    },
    tableType: String,
    dataRows: {
      type: Object,
      default: {},
    },
  },
  components: {
    ShowUpline,
  },
  setup(props) {
    const rows = props.dataRows[props.tableHeader];
    const store = useStore();
    const winRows = ref(
      rows.win.map((x) => ({
        userName: x.userName,
        winLoss: x.winLoss,
        gameId: x.gameId,
      }))
    );
    const lossRows = ref(
      rows.loss.map((x) => ({
        userName: x.userName,
        winLoss: x.winLoss,
        gameId: x.gameId,
      }))
    );
    const checkNameColumn = (column) => {
      if (column.gameId === undefined) {
        return column.userName;
      } else return column.gameId;
    };

    const getUserInfo = async (userData) => {
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/cms/user/list-pagination`;
      const payload = {
        filter: { username: userData.userName },
        operatorId: store.state.selectedOperator.operatorId,
        page: 0,
        pageSize: 10,
        sortBy: [["createdAt", -1]],
      };
      const { data } = await axios.post(url, payload).then(({ data }) => data);
      return data;
    };
    return {
      winRows,
      lossRows,
      checkNameColumn,

      getUserInfo,
    };
  },
};
</script>

<style lang="scss">
.ranking-table {
  width: 100%;
  height: 100%;
  // margin: 1rem 0 0 0;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media only screen and (max-width:550px) {
    grid-template-columns: 1fr;
  }
}
</style>
